export const PublicView = ({
  secondaryColor = "#3b4046",

  primaryFontColor = "rgb(255, 255, 255)",
  width,
  height,
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 31 31">
      <g id="Group_45366" data-name="Group 45366" transform="translate(-3219 -7647)">
        <circle id="Ellipse_1412" data-name="Ellipse 1412" cx="15.5" cy="15.5" r="15.5" transform="translate(3219 7647)" fill={secondaryColor} />
        <g id="Group_45365" data-name="Group 45365" transform="translate(3225.229 7656.965)">
          <path id="Path_65976" data-name="Path 65976" d="M9.248,98.725c-3.534,0-6.739,1.933-9.1,5.074a.732.732,0,0,0,0,.874c2.365,3.144,5.57,5.078,9.1,5.078s6.739-1.933,9.1-5.074a.732.732,0,0,0,0-.874C15.987,100.658,12.782,98.725,9.248,98.725ZM9.5,108.12a3.89,3.89,0,1,1,3.629-3.629A3.893,3.893,0,0,1,9.5,108.12Zm-.117-1.793a2.095,2.095,0,1,1,1.956-1.956A2.091,2.091,0,0,1,9.385,106.326Z" transform="translate(0 -98.725)" fill="#fff" />
        </g>
      </g>
    </svg>
  );
};
